/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Shift } from '../models/Shift';
import { request as __request } from '../core/request';

export class ShiftService {

    /**
     * List shifts for a company
     * @returns Shift List of shifts for the company
     * @throws ApiError
     */
    public static async getShiftListByCompany({
companyId,
}: {
companyId: number,
}): Promise<Array<Shift>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/shift`,
            errors: {
                404: `Company not found`,
            },
        });
        return result.body;
    }

    /**
     * Add a shift for a company
     * @returns Shift Shift created
     * @throws ApiError
     */
    public static async addShift({
companyId,
requestBody,
}: {
companyId: number,
requestBody: Shift,
}): Promise<Shift> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/shift`,
            body: requestBody,
            errors: {
                400: `Invalid request body`,
                404: `Company not found`,
            },
        });
        return result.body;
    }

    /**
     * Get a single shift
     * @returns Shift The requested shift
     * @throws ApiError
     */
    public static async getShift({
companyId,
shiftId,
}: {
companyId: number,
shiftId: number,
}): Promise<Shift> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/shift/${shiftId}`,
            errors: {
                404: `Shift or company not found`,
            },
        });
        return result.body;
    }

    /**
     * Update a shift
     * @returns Shift Shift updated
     * @throws ApiError
     */
    public static async updateShift({
companyId,
shiftId,
requestBody,
}: {
companyId: number,
shiftId: number,
requestBody: Shift,
}): Promise<Shift> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/shift/${shiftId}`,
            body: requestBody,
            errors: {
                400: `Invalid request body`,
                404: `Shift or company not found`,
            },
        });
        return result.body;
    }

    /**
     * Archive a shift
     * @returns any Shift archived successfully
     * @throws ApiError
     */
    public static async archiveShift({
companyId,
shiftId,
}: {
companyId: number,
shiftId: number,
}): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/shift/${shiftId}`,
            errors: {
                404: `Shift or company not found`,
            },
        });
        return result.body;
    }

}